export class TcListConnectionResult<T> {
  pageInfo: any;
  edges: T[];
  total: any;
}
